// extracted by mini-css-extract-plugin
export var container = "pageContainer-module--container--11mnk";